// assets
// import { IconKey } from '@tabler/icons';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';

import { IconDashboard } from '@tabler/icons';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import ChatIcon from '@mui/icons-material/Chat';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';

// constant
const icons = {
  AdminPanelSettingsOutlinedIcon,
  GroupRoundedIcon,
  MonitorHeartOutlinedIcon,
  IconDashboard,
  ReceiptLongIcon,
  SubscriptionsIcon,
  CampaignOutlinedIcon,
  InsightsOutlinedIcon,
  QueryStatsOutlinedIcon,
  LanguageOutlinedIcon,
  PaymentsOutlinedIcon
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const administration = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'default',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard',
        icon: icons.IconDashboard,
        htmlColor: '#ffffff',
        breadcrumbs: false,
        permissions: ['view-dashboard']
      }
    ]
  },
  {
    id: 'administration',
    title: 'Administration',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'roles',
        title: 'Roles Management',
        type: 'item',
        url: '/roles-management',
        icon: icons.AdminPanelSettingsOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false,
        permissions: ['view-roles']
      },
      {
        id: 'admin-users',
        title: 'Admin Users',
        type: 'item',
        url: '/admin-users',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false,
        permissions: ['view-admins']
      },
      {
        id: 'head-coach-users',
        title: 'Head Coaches',
        type: 'item',
        url: '/head-coaches',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false,
        permissions: ['view-head-coaches']
      },
      {
        id: 'trainers',
        title: 'Trainers',
        type: 'item',
        url: '/trainers',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false,
        permissions: ['view-trainers']
      }
    ]
  },

  {
    id: 'library',
    title: 'Library',
    //   caption: 'Pages Caption',
    type: 'group',
    userType: [1, 2],
    permissions: ['view-library'],
    children: [
      {
        id: 'exercise',
        title: 'Exercises',
        type: 'item',
        url: '/exercises-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'warmup',
        title: 'Warm up',
        type: 'item',
        url: '/warmups-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'cool-down',
        title: 'Cool Down',
        type: 'item',
        url: '/cool-downs-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'foods',
        title: 'Food',
        type: 'item',
        url: '/foods-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'content',
    title: 'Programs',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'users',
        title: 'Users',
        type: 'item',
        url: '/users',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false,
        permissions: ['view-app-users']
      },
      {
        id: 'categories',
        title: 'Categories',
        type: 'item',
        url: '/categories',
        icon: ContentPasteIcon,
        breadcrumbs: true,
        permissions: ['view-program-categories']
      }
    ]
  },
  {
    id: 'chat',
    title: 'Chat',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'chat',
        title: 'Chat',
        type: 'item',
        url: '/chat',
        icon: ChatIcon,
        breadcrumbs: true,
        permissions: ['view-chat']
      }
    ]
  },
  {
    id: 'OneToOne',
    title: '1-1 training',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'metric-categories',
        title: 'Metrics',
        type: 'item',
        url: '/metric-categories',
        icon: ContentPasteIcon,
        breadcrumbs: true,
        permissions: ['view-metric-categories']
      },
      {
        id: 'training-requests',
        title: 'Training Requests',
        type: 'item',
        url: '/training-requests',
        icon: ContentPasteIcon,
        breadcrumbs: true,
        permissions: ['view-training-requests']
      },
      {
        id: 'programs',
        title: 'Programs',
        type: 'item',
        url: '/programs?program-type=1',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false,
        permissions: ['view-programs']
      },
      {
        id: 'nutritions',
        title: 'Nutritions',
        type: 'item',
        url: '/nutritions',
        icon: ContentPasteIcon,
        breadcrumbs: false,
        permissions: ['view-nutritions']
      },
      {
        id: 'nutrition-calculator',
        title: 'Calculator',
        type: 'item',
        url: '/nutrition-calculator',
        icon: ContentPasteIcon,
        breadcrumbs: false,
        permissions: ['view-nutritions']
      },
      {
        id: 'assessments',
        title: 'Assessments',
        type: 'item',
        url: '/assessments',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'clients',
        title: 'Clients (Active)',
        type: 'item',
        url: '/clients',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: true,
        permissions: ['view-clients']
      },
      {
        id: 'recovery-board',
        title: 'Recovery Board',
        type: 'item',
        url: '/recovery-board',
        icon: icons.MonitorHeartOutlinedIcon,
        breadcrumbs: true,
        permissions: ['view-clients']
      },
      {
        id: 'expired-clients',
        title: 'Clients (Expired)',
        type: 'item',
        url: '/expired-clients',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: true,
        permissions: ['view-clients']
      }
    ]
  },
  {
    id: 'others',
    title: 'Others',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'plan-finder',
        title: 'Plan Finder',
        type: 'item',
        url: '/plan-finder',
        icon: ContentPasteIcon,
        breadcrumbs: true,
        permissions: ['view-program-categories']
      },
      {
        id: 'plan-finder-insights',
        title: 'Plan Finder Insights',
        type: 'item',
        url: '/plan-finder-insights',
        icon: ContentPasteIcon,
        breadcrumbs: true,
        permissions: ['view-program-categories']
      },
      {
        id: 'plan-finder-rules',
        title: 'Plan Finder Rules',
        type: 'item',
        url: '/plan-finder-rules',
        icon: ContentPasteIcon,
        breadcrumbs: true,
        permissions: ['view-program-categories']
      },
      {
        id: 'training-request-form',
        title: 'Request Form (En)',
        type: 'item',
        url: '/training-request-form-en',
        permissions: ['view-training-request-form']
      },
      {
        id: 'training-request-form-arabic',
        title: 'Request Form (Ar)',
        type: 'item',
        url: '/training-request-form-arabic',
        permissions: ['view-training-request-form']
      },

      {
        id: 'movement-preferences',
        title: 'Movement Preferences',
        type: 'item',
        url: '/app-content/movement-preferences',
        permissions: ['view-movement-preferences']
      },
      {
        id: 'in-app-notifications',
        title: 'In-App Notifications',
        type: 'item',
        url: '/app-content/in-app-notifications',
        permissions: ['view-in-app-notifications']
      },
      {
        id: 'notifications',
        title: 'Notifications',
        type: 'item',
        url: '/app-content/notifications',
        permissions: ['view-notifications']
      },
      {
        id: 'force-update',
        title: 'Force Update',
        type: 'item',
        url: '/app-content/force-update',
        permissions: ['view-notifications']
      },
      {
        id: 'daily-quotes',
        title: 'Daily Quotes',
        type: 'item',
        url: '/app-content/daily-quotes',
        permissions: ['view-daily-quotes']
      },
      {
        id: 'banners',
        title: 'Banners',
        type: 'item',
        url: '/app-content/banners',
        permissions: ['view-banners']
      },
      {
        id: 'faqs',
        title: 'FAQs',
        type: 'item',
        url: '/app-content/faqs',
        permissions: ['view-faqs']
      },
      // {
      //   id: 'feedbacks',
      //   title: 'Feedbacks',
      //   type: 'item',
      //   url: '/app-content/feedbacks'
      // },
      {
        id: 'privacy-policy',
        title: 'Privacy Policy',
        type: 'item',
        url: '/app-content/privacy-policy',
        permissions: ['view-privacy-policy']
      },
      {
        id: 'terms',
        title: 'Terms and Conditions',
        type: 'item',
        url: '/app-content/terms',
        permissions: ['view-terms-and-conditions']
      },
      {
        id: 'about-us',
        title: 'About us',
        type: 'item',
        url: '/app-content/about-us',
        permissions: ['view-about-us']
      },
      {
        id: 'subscription-list',
        title: 'Subscriptions',
        type: 'item',
        url: '/app-content/subscription-list',
        permissions: ['view-subscriptions']
      },
      {
        id: 'coupon-list',
        title: 'Coupons',
        type: 'item',
        url: '/app-content/coupon-list',
        permissions: ['view-coupons']
      }
    ]
  },
  {
    id: 'transactions',
    title: 'Transactions',
    //   caption: 'Pages Caption',
    type: 'group',
    userType: [1, 2],
    permissions: ['view-transactions', 'view-subscriptions'],
    children: [
      {
        id: 'user-subscriptions',
        title: 'User Subscriptions',
        type: 'item',
        url: '/user-subscriptions',
        icon: icons.SubscriptionsIcon,
        breadcrumbs: false,
        permissions: ['view-user-subscriptions']
      },
      {
        id: 'transactions',
        title: 'Transactions',
        type: 'item',
        url: '/transactions',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false,
        permissions: ['view-transactions']
      },
      {
        // A native portal page now, not the website admin in a frame. That is
        // why the super-admin-only gate is gone: it existed solely because the
        // framed page's session exchange rejects everyone else with a 403.
        // Access is governed by a permission, like every other screen.
        id: 'instapay',
        title: 'InstaPay',
        type: 'item',
        url: '/instapay',
        icon: icons.PaymentsOutlinedIcon,
        breadcrumbs: false,
        permissions: ['view-instapay']
      }
    ]
  },
  {
    // userType [1] on purpose: super admin only. The page emails paying and
    // nearly-paying clients, so it is not something a granular permission opens.
    id: 'marketing',
    title: 'Marketing',
    type: 'group',
    userType: [1],
    children: [
      {
        id: 'win-back',
        title: 'Win-back campaign',
        type: 'item',
        url: '/marketing/win-back',
        icon: icons.CampaignOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'broadcast-email',
        title: 'Broadcast email',
        type: 'item',
        url: '/marketing/broadcast',
        icon: icons.CampaignOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'marketing-dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/marketing/dashboard',
        icon: icons.QueryStatsOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'funnel',
        title: 'Marketing funnel',
        type: 'item',
        url: '/marketing/funnel',
        icon: icons.InsightsOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      }
    ]
  },
  {
    // userType [1] on purpose: super admin only. Portal accounts and the
    // website's own admin accounts were never the same list, so opening the CMS
    // to every portal user would hand people the ability to edit the live site
    // as a side effect of a change nobody asked for. Widen it deliberately.
    id: 'website',
    title: 'Website admin panel',
    type: 'group',
    userType: [1],
    children: [
      {
        id: 'website-overview',
        title: 'Overview',
        type: 'item',
        url: '/website',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-content',
        title: 'Pages & content',
        type: 'item',
        url: '/website/content',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-media',
        title: 'Media library',
        type: 'item',
        url: '/website/media',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-programs',
        title: 'Programs',
        type: 'item',
        url: '/website/programs',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-pricing',
        title: 'Pricing',
        type: 'item',
        url: '/website/pricing',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-offers',
        title: 'Offers',
        type: 'item',
        url: '/website/offers',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-leads',
        title: 'Leads',
        type: 'item',
        url: '/website/leads',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'site-payments',
        title: 'Payments',
        type: 'item',
        url: '/site/payments',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false,
        permissions: ['view-site-analytics']
      },
      {
        id: 'website-chat',
        title: 'Website chat',
        type: 'item',
        url: '/website/chat',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'site-visits',
        title: 'Visits',
        type: 'item',
        url: '/site/visits',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false,
        permissions: ['view-site-analytics']
      },
      {
        id: 'website-journeys',
        title: 'Journeys',
        type: 'item',
        url: '/website/journeys',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'site-campaigns',
        title: 'Campaigns',
        type: 'item',
        url: '/site/campaigns',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false,
        permissions: ['view-site-analytics']
      },
      {
        id: 'website-globals',
        title: 'Site settings',
        type: 'item',
        url: '/website/globals',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-versions',
        title: 'Versions',
        type: 'item',
        url: '/website/versions',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-security',
        title: 'Security',
        type: 'item',
        url: '/website/security',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      },
      {
        id: 'website-users',
        title: 'Website admins',
        type: 'item',
        url: '/website/users',
        icon: icons.LanguageOutlinedIcon,
        htmlColor: '#ffffff',
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'emptyAdmin',
    title: '',
    type: 'group',
    userType: [1, 2],
    children: [
      {
        id: 'empty1',
        title: '',
        type: 'empty',
        url: '#',
        icon: 'empty',
        breadcrumbs: false,
        permissions: ['']
      },
      {
        id: 'empty2',
        title: '',
        type: 'empty',
        url: '#',
        icon: 'empty',
        breadcrumbs: false,
        permissions: ['']
      }
    ]
  }
];

export default administration;
